'use strict';

var chunk4HPJYH4J_js = require('./chunk-4HPJYH4J.js');



module.exports = chunk4HPJYH4J_js.Profile;
